import { useMemo } from 'react';

import { socialIconLinks } from './page-share.constants';
import type { SocialLinks, SocialName } from './page-share.types';

export const useSocialLinks = (socialLinks: SocialLinks) =>
  useMemo(
    () =>
      Object.keys(socialLinks)
        .filter((name) => socialLinks[name as SocialName])
        .map((name) => socialIconLinks[name as SocialName]),
    [socialLinks],
  );
